import { createFilterOptions } from '@material-ui/lab/Autocomplete'
import lodash from 'lodash'
import { IFilterOptionsParams, IOptionProps } from './types'

const filter = createFilterOptions<IOptionProps>()

export const filterOptions = (options: IOptionProps[], params: IFilterOptionsParams) => {
  const filtered = filter(options, params)

  if (params.inputValue !== '') {
    filtered.push({
      title: params.inputValue,
      inputValue: params.inputValue,
    })
  }

  return lodash.uniqBy(filtered, 'title')
}
